import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DATE_RANGE_PRESETS } from './filterOptions';
import './DateRangePopover.css';

/**
 * Inline two-month range picker with quick presets.
 * Calls `onChange(start, end)` on every pick and `onComplete()` once both
 * ends are set so the parent can close the popover.
 */
const DateRangePopover = ({ startDate, endDate, onChange, onComplete, note }) => {
    const handleChange = (dates) => {
        const [start, end] = Array.isArray(dates) ? dates : [dates, null];
        onChange(start, end);
        if (start && end) onComplete?.();
    };

    const applyPreset = (preset) => {
        const [start, end] = preset.getRange();
        onChange(start, end);
        onComplete?.();
    };

    return (
        <div className="date-range-popover">
            <div className="date-range-popover__presets" role="group" aria-label="Quick ranges">
                {DATE_RANGE_PRESETS.map((preset) => (
                    <button
                        key={preset.key}
                        type="button"
                        className="date-range-popover__preset"
                        onClick={() => applyPreset(preset)}
                    >
                        {preset.label}
                    </button>
                ))}
            </div>

            <div className="date-range-popover__calendar">
                <DatePicker
                    inline
                    selectsRange
                    monthsShown={2}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleChange}
                    maxDate={new Date()}
                    calendarStartDay={1}
                />
            </div>

            {note && <div className="date-range-popover__note">{note}</div>}
        </div>
    );
};

export default DateRangePopover;
